import { CompanySetting } from "domain-entities";
import moment from "moment";

export const getStartOfWeek = (
	weekPlus: number,
	companySettings?: CompanySetting
) => {
	const workingDays = companySettings?.workingDays;
	const startOfWeek = moment().startOf("week");

	/**
	 * isoWeekday will be different depending on browser country/language.
	 * en: 7 (Sunday)
	 * de: 1 (Monday)
	 */
	const isoWeekday = startOfWeek.isoWeekday();
	const isSundayEnabled = workingDays ? !!workingDays[6]?.enabled : true;

	if (isoWeekday === 7 && !isSundayEnabled) {
		startOfWeek.add(1, "day");
	}

	return startOfWeek.add(weekPlus, "weeks");
};
